<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />

    <div class="mb-2">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <router-link to="/elemento">Elementos</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            {{ datoElemento.nombre || p_idElemento }}
          </li>
        </ol>
      </nav>
    </div>
    <hr />

    <div class="card mb-4 shadow-sm">
      <div class="card-body">
        <form>
          <div class="mb-3" v-if="btnEditar">
            <div class="row">
              <div class="col-2"><label class="form-label fw-bold">ID</label></div>
              <div class="col-10">
                <input type="text" class="form-control" v-model="datoElemento.idElemento" disabled />
              </div>
            </div>
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col-2"><label class="form-label fw-bold">Clas. Elem</label></div>
              <div class="col-10">
                <select class="form-select" v-model="datoElemento.idClasElem">
                  <option v-for="clasElem in clasElems" :value="clasElem.idClasElem" :key="clasElem.idClasElem">
                    {{ clasElem.nombre }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col-2"><label class="form-label fw-bold">Código</label></div>
              <div class="col-10">
                <input
                  type="text"
                  class="form-control"
                  v-model="datoElemento.codigo"
                  style="text-transform:uppercase"
                  required
                />
              </div>
            </div>
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col-2"><label class="form-label fw-bold">Nombre</label></div>
              <div class="col-10">
                <textarea
                  class="form-control"
                  v-model="datoElemento.nombre"
                  style="text-transform:uppercase"
                  rows="2"
                ></textarea>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="card-footer d-flex gap-2">
        <button type="button" class="btn btn-primary" @click.prevent="guardarElemento" v-if="btnCrear">
          <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
          Guardar
        </button>
        <button type="button" class="btn btn-warning" @click.prevent="guardarEditElemento" v-if="btnEditar">
          <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
          Actualizar
        </button>
      </div>
    </div>

    <h5 class="mb-3">
      <span class="material-icons align-middle me-1" style="font-size:20px">payments</span>
      Tarifas por Prestador
    </h5>

    <DataTable
      :data="tarifapress"
      :columns="columnasDet"
      idField="idTarifaPres"
      mensajeVacio="No hay tarifas configuradas para este elemento."
      :mostrarBotonNuevo="true"
      :mostrarEditar="true"
      :mostrarVer="false"
      :mostrarEliminar="true"
      @refresh="getDataTodos"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idTarifaPres)"
      @delete="row => deleteTarifaPres(row.idTarifaPres)"
    >
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Buscar prestador..."
            style="width:220px; text-transform:uppercase"
            @keyup.enter="getDataNombre"
          />
          <button class="btn btn-outline-primary btn-sm" @click="getDataNombre" title="Buscar">
            <span class="material-icons" style="font-size:16px">search</span>
          </button>
        </div>
      </template>

      <template #cell-valor="{ row }">
        {{ row.valor }}
      </template>
    </DataTable>

    <div class="modal fade" id="ventanaModal" tabindex="-1" aria-hidden="true" v-if="modalWindow">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">
              <span class="material-icons align-middle me-1">add_circle</span> {{ titulo }}
            </h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="mb-3" v-if="btnEditar_det">
                <div class="row">
                  <div class="col-3"><label class="form-label fw-bold">ID Tarifa Pres</label></div>
                  <div class="col-9">
                    <input type="text" class="form-control" v-model="datoTarifaPres.idTarifaPres" disabled />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-3"><label class="form-label fw-bold">Prestador</label></div>
                  <div class="col-9">
                    <select class="form-select" v-model="datoTarifaPres.idPrestador">
                      <option v-for="p in prestadors" :value="p.idPrestador" :key="p.idPrestador">
                        {{ p.nombreComercial }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-3"><label class="form-label fw-bold">Tarifa Conv</label></div>
                  <div class="col-9">
                    <select class="form-select" v-model="datoTarifaPres.idTarifaConv">
                      <option v-for="tc in tarifaConvs" :value="tc.idTarifaConv" :key="tc.idTarifaConv">
                        {{ tc.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-3"><label class="form-label fw-bold">Valor</label></div>
                  <div class="col-9">
                    <input type="number" step="0.01" class="form-control" v-model="datoTarifaPres.valor" required />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click.prevent="guardarTarifaPres" v-if="btnCrear_det">
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span> Guardar
            </button>
            <button type="button" class="btn btn-warning" @click.prevent="guardarEditTarifaPres" v-if="btnEditar_det">
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span> Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import DataTable from "@/components/DataTable.vue";
import api from "@/services/api";
import Swal from "sweetalert2"; // Consistencia con ClasDiag
import * as $ from "jquery";

export default {
  name: "ElementoTarifaForm",
  components: { Layout, Footer, DataTable },

  data() {
    return {
      // ── Master ──────────────────────────────────────────────
      p_idElemento: "",
      p_idEmpresa: 0,
      datoElemento: {},
      clasElems: [],
      btnCrear: false,
      btnEditar: false,

      // ── Detail ──────────────────────────────────────────────
      tarifapress: [],
      datoTarifaPres: {},
      prestadors: [],
      tarifaConvs: [],
      nombreBusqueda: "",
      titulo: "",
      btnCrear_det: false,
      btnEditar_det: false,
      modalWindow: true,
    };
  },

  computed: {
    columnasDet() {
      return [
        { label: "Prestador", field: "prestadorNombreComercial" },
        { label: "Valor", field: "valor" },
        { label: "Estado", field: "estado" },
      ];
    },
  },

  mounted() {
    this.p_idEmpresa = window.sessionStorage.getItem("idEmpresa");
    this.p_idElemento = this.$route.params.p_idelemento;

    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();

    this.cargarMaster();
    this.getDataTodos();
    this.fetchCatalogos();
  },

  methods: {
    // ── Master ────────────────────────────────────────────────
    async cargarMaster() {
      if (!this.p_idElemento) {
        this.btnCrear = true;
        return;
      }
      try {
        const resp = await api.get("/vwelementos/" + this.p_idElemento);
        this.datoElemento = resp.data;
        this.btnEditar = true;
      } catch (e) {
        console.error("Error al cargar elemento:", e);
      }
    },

    validarFormMaster() {
      if (!this.datoElemento.codigo || !this.datoElemento.nombre || !this.datoElemento.idClasElem) {
        Swal.fire({ icon: "error", title: "Error", text: "Complete los campos obligatorios del elemento." });
        return 0;
      }
      return 1;
    },

    async guardarElemento() {
      if (this.validarFormMaster() !== 1) return;
      try {
        await api.post("/elementos", this.datoElemento);
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Elemento creado exitosamente." });
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    async guardarEditElemento() {
      if (this.validarFormMaster() !== 1) return;
      try {
        await api.post("/elementos", this.datoElemento);
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Elemento actualizado exitosamente." });
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo actualizar." });
      }
    },

    // ── Detail — carga de datos ───────────────────────────────
    async getDataTodos() {
      this.nombreBusqueda = "";
      try {
        const r = await api.get(`/vwtarifapress/idelemento/${this.p_idElemento}`);
        this.tarifapress = Array.isArray(r.data) ? r.data : [];
      } catch (e) {
        console.error("Error al cargar tarifas:", e);
      }
    },

    async getDataNombre() {
      const nombre = this.nombreBusqueda.trim();
      if (!nombre) { this.getDataTodos(); return; }
      try {
        const r = await api.get(`/vwtarifapress/nombre/${nombre}`);
        this.tarifapress = Array.isArray(r.data) ? r.data : [];
      } catch (e) {
        console.error("Error al buscar prestador:", e);
      }
    },

    // ── Detail — CRUD ─────────────────────────────────────────
    async guardarTarifaPres() {
      try {
        this.datoTarifaPres.idElemento = this.p_idElemento;
        await api.post("/tarifapress", this.datoTarifaPres);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Tarifa creada exitosamente." });
        this.getDataTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    async guardarEditTarifaPres() {
      try {
        await api.post("/tarifapress", this.datoTarifaPres);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Tarifa actualizada exitosamente." });
        this.getDataTodos();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo actualizar." });
      }
    },

    async deleteTarifaPres(id) {
      const confirm = await Swal.fire({
        title: "¿Eliminar tarifa?",
        text: "Esta acción no se puede deshacer.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/tarifapress/" + id);
        this.getDataTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },

    // ── Auxiliares ────────────────────────────────────────────
    async fetchCatalogos() {
      try {
        const [ce, pr, tc] = await Promise.all([
          api.get("/vwclaselems"),
          api.get("/vwprestadors/idempresa/" + this.p_idEmpresa),
          api.get("/vwtarifaconvs")
        ]);
        this.clasElems = ce.data;
        this.prestadors = pr.data;
        this.tarifaConvs = tc.data;
      } catch (e) {
        console.error("Error cargando catálogos:", e);
      }
    },

    abrirModalCrear() {
      this.datoTarifaPres = { idElemento: this.p_idElemento };
      this.titulo = "Crear Tarifa";
      this.btnCrear_det = true;
      this.btnEditar_det = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    async abrirModalEditar(id) {
      this.titulo = "Editar Tarifa";
      this.btnCrear_det = false;
      this.btnEditar_det = true;
      try {
        const resp = await api.get("/vwtarifapress/" + id);
        this.datoTarifaPres = resp.data;
        this.$nextTick(() => $("#ventanaModal").modal("show"));
      } catch (e) {
        console.error("Error al cargar detalle:", e);
      }
    },
  },
};
</script>